module.exports = __webpack_public_path__ + "thumbnail-b52d5425b64f6436abbdb0840625c279.png";